export type Theme = "light" | "dark";

export const LIGHT_DEFAULT_THEME_HOSTNAME = "bigr-app.takeres.com";

export function resolveInitialTheme({
  hostname,
  prefersDark,
  storedTheme,
}: {
  hostname: string;
  prefersDark: boolean;
  storedTheme: string | null;
}): Theme {
  if (storedTheme === "light" || storedTheme === "dark") {
    return storedTheme;
  }

  if (hostname.toLowerCase() === LIGHT_DEFAULT_THEME_HOSTNAME) {
    return "light";
  }

  return prefersDark ? "dark" : "light";
}
